import { Box, Stack } from '@mui/material'
import { IContentBlock } from 'App/Epi/BlockMapper/BlockMapper'
import { IntroductionContentProps } from 'App/Epi/Blocks/Introduction/Introduction'
import { RelatedContentProps } from 'App/components/RelatedContent/RelatedContent'
import { GuideWithNavigationContent } from './Components/GuideWithNavigationContent'
import { GuideNavigationPageDto } from './DTOs/GuideNavigationPageDto'
import { GuideNavigationStepData } from 'App/Epi/Blocks/GuideNavigationBlock/data/GuideNavigationStepData'
import { GuideNavigationChapterData } from 'App/Epi/Blocks/GuideNavigationBlock/data/GuideNavigationChapterData'
import { GuideNavigationAccordionBlock } from 'App/Epi/Blocks/GuideNavigationBlock/GuideNavigationAccordionBlock'
import { GuideNavigationDropdownBlock } from 'App/Epi/Blocks/GuideNavigationBlock/GuideNavigationDropdownBlock'
import { ArticleVideoBlockProps } from 'App/Epi/Blocks/ArticleVideoBlock/ArticleVideoBlock'

export interface GuideWithNavigationProps {
  introduction: IntroductionContentProps
  image: string
  videoArea?: ArticleVideoBlockProps[]
  editor: string
  blocks?: IContentBlock[]
  guideNavigation: GuideNavigationPageDto[]
  relatedContent?: RelatedContentProps[]
}

const GuideWithNavigation = ({
  introduction,
  image,
  videoArea = [],
  editor,
  blocks,
  guideNavigation,
  relatedContent,
}: GuideWithNavigationProps) => {
  const guideNavigationChapters = mapGuideNavigationChapterData(guideNavigation)

  return (
    <Stack
      direction={{ xs: 'column-reverse', md: 'row' }}
      gap={2}
      justifyContent="space-between"
    >
      <Box flex={1} minWidth={0} maxWidth={{ xs: '100%', md: '752px' }}>
        <GuideWithNavigationContent
          introduction={introduction}
          image={image}
          editor={editor}
          blocks={blocks}
          relatedContent={relatedContent}
          videoProperties={videoArea?.map((video) => ({
            properties: video.properties,
          }))}
        />
      </Box>

      <Box width="288px" display={{ xs: 'none', md: 'block' }}>
        <GuideNavigationAccordionBlock chapters={guideNavigationChapters} />
      </Box>
      <Box width="100%" display={{ xs: 'block', md: 'none' }}>
        <GuideNavigationDropdownBlock chapters={guideNavigationChapters} />
      </Box>
    </Stack>
  )
}

const mapGuideNavigationChapterData = (
  guideNavigation: GuideNavigationPageDto[]
) => {
  let currentStep = 1
  const guideNavigationChapters: GuideNavigationChapterData[] =
    guideNavigation.map(({ title, children }) => ({
      title: title ?? '',
      steps: children.map(({ title, description, url }) => ({
        title: `${currentStep++}. ${title ?? ''}`,
        description: description ?? '',
        link: url,
      })) as GuideNavigationStepData[],
    }))

  return guideNavigationChapters
}

export default GuideWithNavigation
